import { BASE_LOG } from "../const";

export function getExponentialValue(value: number) {
  return value > 1 ? Math.floor(Math.log(value) / BASE_LOG) : 0;
}
